<header id="main-header">
  <mat-toolbar color="primary" id="toolbar">
      <a [routerLink]="homeLink" *ngIf="!searchIsOpened" class="home__logo">
        <img src="./assets/logo_anim.svg" alt="City Expert" width="180"/>
      </a>
      <span class="app-toolbar-filler"></span>
      <div class="btn-top only-desktop">
        <div class="head-elem" *ngIf="headerService.isAgent">
          <div class="agent-credit">
            {{headerService.agentCredit | currency:currencyService.currencyStr:true:'1.2-2'}}
          </div>
        </div>
        <div class="head-elem">
            <input #search [(ngModel)]="searchText" class="searchbox" type="search" placeholder="{{'SEARCH_TEXT' | translate}}" [formControl]="searchingLocations"
            matInput [matAutocomplete]="auto" (keyup.enter)="searchWord(search.value)">
            <mat-autocomplete #auto="matAutocomplete">
              <div class="mat-options">
                <mat-option class="options-home" *ngFor="let result of searchResults?.locations" (click)="navToCity(result)" [value]="result.location">
                    <mat-icon matPrefix>place</mat-icon>  {{ result.location }}
                </mat-option>
                <mat-option class="options-home" *ngFor="let result of searchResults?.products" (click)="navToProduct(result)" [value]="result.name">
                    <mat-icon matPrefix>local_play</mat-icon>  {{ result.name }}
                </mat-option>
                <mat-option *ngIf='noResults && searchText && searchText.length > 2' class="options-home">
                  <mat-icon matPrefix>sentiment_dissatisfied</mat-icon> {{'SEARCH_NO_RESULT' | translate}}
                </mat-option>
            </div>
          </mat-autocomplete>
        </div>
        <div class="head-elem">
          <select class="head-selector" (change)="changeLanguage($event.target.value)" [(ngModel)]="headerService.locale">
            <option value="en">ENG</option>
            <option value="es">ESP</option>
            <!-- <option value="it">ITA</option> -->
            <!-- <option value="fr">FRA</option> -->
            <!-- <option value="de">DEU</option> -->
          </select>
        </div>
        <div class="head-elem" *ngIf="!headerService.isAgent">
          <select class="head-selector" (change)="changeCurrency($event.target.value)" [(ngModel)]="currency">
             <option value="1" selected>&euro; (EUR)</option>
             <!-- <option value="2">&pound; (GBP)</option> -->
             <!-- <option value="3">&#36; (USD)</option> -->
          </select>
        </div>
        <div class="icon with-notification head-elem" (click)="goBasket()">
          <div class="notification" *ngIf="headerService.numElementsCart != 0">
            {{headerService.numElementsCart}}
          </div>
          <mat-icon>shopping_cart</mat-icon>
        </div>
        <div class="icon with-notification head-elem" (click)="logout()" *ngIf="headerService.isAgent">
          <mat-icon>exit_to_app</mat-icon>
        </div>
      </div>
      <div class="btn-top only-mobile">
        <div class="head-elem" *ngIf="searchIsOpened && !secondBarIsOpened">
          <input class="searchbox" type="search" placeholder="{{'SEARCH_TEXT' | translate}}" [formControl]="searchingLocations">
          <div class="search-results search-results-mobile" >
            <mat-option class="options-home options-home-mobile" *ngFor="let result of searchResults?.locations" (click)="navToCity(result)" [value]="result.location">
                <mat-icon class="options-icon-mobile" matPrefix>place</mat-icon>  {{ result.location }}
            </mat-option>
            <mat-option class="options-home options-home-mobile" *ngFor="let result of searchResults?.products" (click)="navToProduct(result)" [value]="result.name">
                <mat-icon class="options-icon-mobile" matPrefix>local_play</mat-icon>  {{ result.name }}
            </mat-option>
          </div>
        </div>
        <div class="head-elem" *ngIf="searchIsOpened && !secondBarIsOpened" (click)="toggleSearch()">
          <mat-icon>close</mat-icon>
        </div>
        <div class="head-elem" *ngIf="!searchIsOpened && !secondBarIsOpened" (click)="toggleSearch()">
          <mat-icon>search</mat-icon>
        </div>
        <div class="icon with-notification head-elem" (click)="goBasket()" *ngIf="!secondBarIsOpened"> 
          <div class="notification" *ngIf="headerService.numElementsCart > 0">
            {{headerService.numElementsCart}}
          </div>
          <mat-icon>shopping_cart</mat-icon>
        </div>
        <div class="icon with-notification head-elem" (click)="logout()" *ngIf="headerService.isAgent && !secondBarIsOpened">
          <mat-icon>exit_to_app</mat-icon>
        </div>
        <div class="head-elem" *ngIf="!secondBarIsOpened" (click)="toggleSecondBar()">
          <mat-icon>more_vert</mat-icon>
        </div>
  
        <div class="head-elem" *ngIf="headerService.isAgent && secondBarIsOpened">
          <div class="agent-credit">
            {{headerService.agentCredit | currency:currencyService.currencyStr:true:'1.2-2'}}
          </div>
        </div>
        <div class="head-elem no-margin" *ngIf="secondBarIsOpened">
          <select class="head-selector" (change)="changeLanguage($event.target.value)" [(ngModel)]="headerService.locale">
            <option value="en">ENG</option>
            <option value="es">ESP</option>
            <!-- <option value="it">ITA</option> -->
            <!-- <option value="fr">FRA</option> -->
            <!-- <option value="de">DEU</option> -->
          </select>
        </div>
  
        <div class="head-elem no-margin" *ngIf="!headerService.isAgent && secondBarIsOpened">
          <select class="head-selector" (change)="changeCurrency($event.target.value)" [(ngModel)]="currency">
             <option value="1" selected>&euro; (EUR)</option>
             <!-- <option value="2">&pound; (GBP)</option> -->
             <!-- <option value="3">&#36; (USD)</option> -->
          </select>
        </div>
  
        <div class="head-elem" *ngIf="secondBarIsOpened" (click)="toggleSecondBar()">
          <mat-icon>more_horiz</mat-icon>
        </div>
      </div>
    </mat-toolbar>
</header>

<div class="content">
  <router-outlet></router-outlet>
</div>

<div *ngIf="showUpButton" class="showup mdl-cell--hide-phone mdl-cell--hide-tablet" (click)="moveToUp()">
  <button matTooltip="Move to top" [matTooltipPosition]="'above'"><i class="material-icons">
    keyboard_arrow_up
    </i></button>
</div>
<footer>
  <div class="md-cell mdl-cell--hide-phone mdl-cell--hide-tablet">
    <div class="container">
      <div class="container__top">
        <div>
            <img height="60px" width="220px" src="./assets/logo_anim.svg" alt="City Expert">
        </div>
        <div>
          <img height="60px" width="auto" src="./assets/images/aenor_iso_9001.png" alt="City Expert">
        </div>
        <div>
          <ul class="container__top__list">
            <li class="container__top__list__item">
              <a target="_blank" href="https://www.facebook.com/CityExpertTravel/">
                <img src="../assets/images/facebook_logo_22px.png" alt="Facebook logo">
              </a>
            </li>
            <li class="container__top__list__item">
              <a target="_blank" href="https://x.com/CityExpert_">
                <img src="../assets/images/logo-x-22-22.png" alt="X logo">
              </a>
            </li>
            <li class="container__top__list__item">
              <a target="_blank" href="https://www.instagram.com/city_expert">
                <img src="../assets/images/instagram_logo_22px.png" alt="Instagram logo">
              </a>
            </li>
            <li class="container__top__list__item">
              <a target="_blank" href="https://www.youtube.com/channel/UCSr8c585tIXeuu45FIzZA1Q">
                <img src="../assets/images/youtube_logo_22px.png" alt="Youtube logo">
              </a>
            </li>
            <li class="container__top__list__item">
              <a target="_blank" href="https://www.linkedin.com/company/cityexpert-worldwide/">
                <img src="../assets/images/linkedin_logo_22px.png" alt="Linkedin logo">
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="container__bottom">
        <ul class="container__bottom__list">
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'FAQ_URL' | translate}}">{{'FAQS_ABREVATION' | translate}}</a>
          </li>
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'ABOUT_US_URL' | translate}}"> {{'ABOUT_US' | translate}} </a>
          </li>
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'CAREERS_URL' | translate}}"> {{'CAREERS' | translate}} </a>
          </li>
          <li class="container__bottom__list__item">
              <a routerLink="/{{'LANG' | translate}}/{{'CONTACT_URL' | translate}}">{{'CONTACT' | translate}}</a>
          </li>
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'COMPANY_POLICY_URL' | translate}}">{{'COMPANY_POLICY' |
              translate}}</a>
          </li>
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'COOKIES_POLICY_URL' | translate}}">{{'COOKIES_POLICY_2' |
              translate}}</a>
          </li>
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'TERMS_OF_USE_URL' | translate}}">{{'TERMS_OF_USE_FOOT' |
              translate}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="!cookiesAccepted" class="footer-legal-textB">
      <span>{{'COOKIE_FOOTER_MESSAGE' | translate}}
        <a routerLink="/{{'LANG' | translate}}/{{'COOKIES_POLICY_URL' | translate}}">{{'COOKIES_POLICY' | translate}}</a>
        <button mat-button color="primary" (click)="acceptCookies($event)" class="accept-cookies">OK</button>
      </span>
    </div>
  </div>
  <div class="mdl-cell--hide-desktop">
    <div class="container__phone">
      <div class="container__phone__top">
        <div class="container__phone__top__logo">
            <img height="60px" width="220px" src="./assets/logo_anim.svg" alt="City Expert">
        </div>
        <div class="container__phone__top__qa">
          <img height="60px" width="auto" src="./assets/images/aenor_iso_9001.png" alt="City Expert">
        </div>
        <ul class="container__phone__top__list">
          <li class="container__phone__top__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'FAQ_URL' | translate}}">{{'FAQS_ABREVATION' | translate}}</a>
          </li>
          <li class="container__phone__top__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'ABOUT_US_URL' | translate}}"> {{'ABOUT_US' | translate}} </a>
          </li>
          <li class="container__phone__top__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'CAREERS_URL' | translate}}"> Careers </a>
          </li>
          <li class="container__phone__top__list__item">
              <a routerLink="/{{'LANG' | translate}}/{{'CONTACT_URL' | translate}}">{{'CONTACT' | translate}}</a>
          </li>
          <li class="container__bottom__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'COMPANY_POLICY_URL' | translate}}">{{'COMPANY_POLICY' |
              translate}}</a>
          </li>
          <li class="container__phone__top__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'COOKIES_POLICY_URL' | translate}}">{{'COOKIES_POLICY_2' |
              translate}}</a>
          </li>
          <li class="container__phone__top__list__item">
            <a routerLink="/{{'LANG' | translate}}/{{'TERMS_OF_USE_URL' | translate}}">{{'TERMS_OF_USE_FOOT' |
              translate}}</a>
          </li>
        </ul>
      </div>
      <div class="container__phone__bottom">
        <ul class="container__phone__bottom__list">
          <li class="container__phone__bottom__list__item">
            <a target="_blank" href="https://www.facebook.com/CityExpertTravel/">
              <img src="../assets/images/facebook_logo_22px.png" alt="Facebook logo">
            </a>
          </li>
          <li class="container__phone__bottom__list__item">
            <a target="_blank" href="https://x.com/CityExpert_">
              <img src="../assets/images/logo-x-22-22.png" alt="X logo">
            </a>
          </li>
          <li class="container__phone__bottom__list__item">
            <a target="_blank" href="https://www.instagram.com/city_expert">
              <img src="../assets/images/instagram_logo_22px.png" alt="Instagram logo">
            </a>
          </li>
          <li class="container__phone__bottom__list__item">
            <a target="_blank" href="https://www.youtube.com/channel/UCSr8c585tIXeuu45FIzZA1Q">
              <img src="../assets/images/youtube_logo_22px.png" alt="Youtube logo">
            </a>
          </li>
          <li class="container__phone__bottom__list__item">
            <a target="_blank" href="https://www.linkedin.com/company/cityexpert-worldwide/">
              <img src="../assets/images/linkedin_logo_22px.png" alt="Linkedin logo">
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div id="coockies-form" *ngIf="!cookiesAccepted" class="footer-phone-legalB">
      <span>{{'COOKIE_FOOTER_MESSAGE' | translate}}
        <a routerLink="/{{'LANG' | translate}}/{{'COOKIES_POLICY_URL' | translate}}">{{'COOKIES_POLICY_2' | translate}}</a>
      </span>
      <button mat-button color="primary" (click)="acceptCookies()" class="accept-cookies">OK</button>
    </div>

  </div>
</footer>